import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Form,
    Alert,
    Button,
    Card,
    Table
} from "../../../../node_modules/react-bootstrap";
import { CommonController } from "../../../Controllers/CommonController";
import { FormModalSpinner } from "../../CustomComponents/FormModalSpinner";

interface IUserActivityParameter {
    history: any;
}

interface IUserActivityItem {
    User_ID: string;
    Name: string;
    User_Type: string;
    Logged_In: string;
    Last_Logged_In: string;
    Last_Logged_Out: string;
    Last_Activity: string;
    Shadow: string;
    Script: string;
    Agent: string;
    URL_Used?: string;
}

interface IUserActivityState {
    fields: {
        forValue: string;
        fromDate: string;
        toDate: string;
        search: string;
        searchField: string;
    };
    errors: {
        search: string;
    };
    errMsg: string;
    users: IUserActivityItem[];
    loading: boolean;
    loggedIn: boolean;
    modal: {
        modalSpinnerShow: boolean;
    };
}

export class UserActivity extends Component<IUserActivityParameter, IUserActivityState> {
    constructor(props: IUserActivityParameter) {
        super(props);

        const userLogin = sessionStorage.getItem("userLogin");
        let loggedIn = true;
        if (userLogin == null) {
            loggedIn = false;
        }

        this.state = {
            fields: {
                forValue: "Last 3 days",
                fromDate: this.formatDateForInput(new Date()),
                toDate: this.formatDateForInput(new Date()),
                search: "*",
                searchField: "Name"
            },
            errors: {
                search: ""
            },
            errMsg: "",
            users: [],
            loading: false,
            loggedIn: loggedIn,
            modal: {
                modalSpinnerShow: false
            }
        };

        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleForValueChange = this.handleForValueChange.bind(this);
    }

    componentDidMount() {
        // optional: load default data on page load
        this.onSubmit({
            preventDefault: () => {}
        });
    }

    formatDateForInput(date: Date) {
        const year = date.getFullYear();
        let month: string | number = date.getMonth() + 1;
        let day: string | number = date.getDate();

        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;

        return `${year}-${month}-${day}`;
    }

    formatDisplayDate(value: any) {
        if (!value) return "";
        try {
            return new Date(value).toLocaleString();
        } catch {
            return value;
        }
    }

    handleChange(e: any) {
        let fields = this.state.fields;
        fields[e.currentTarget.name] = e.currentTarget.value;
        this.setState({ fields });
    }

    

    handleForValueChange(e: any) {
        let fields = this.state.fields;
        fields["forValue"] = e.currentTarget.value;

        const today = new Date();
        let fromDate = new Date();
        if (e.currentTarget.value === "All") {
            fromDate = new Date(2000, 0, 1);
            //fromDate.setDate(today.getDate());
        }
        else if (e.currentTarget.value === "Last 3 days") {
            fromDate.setDate(today.getDate() - 3);
        } else if (e.currentTarget.value === "Last 7 days") {
            fromDate.setDate(today.getDate() - 7);
        } else if (e.currentTarget.value === "Last 30 days") {
            fromDate.setDate(today.getDate() - 30);
        } else if (e.currentTarget.value === "Last 45 days") {
            fromDate.setDate(today.getDate() - 45);
        }  else if (e.currentTarget.value === "Last 60 days") {
            fromDate.setDate(today.getDate() - 60);
        }  else if (e.currentTarget.value === "Last 90 days") {
            fromDate.setDate(today.getDate() - 90);
        }  else {
            // Custom - do not auto change
            this.setState({ fields });
            return;
        }

        fields["fromDate"] = this.formatDateForInput(fromDate);
        fields["toDate"] = this.formatDateForInput(today);

        this.setState({ fields });
    }

    ValidateProfile() {
        let errors = this.state.errors;
        let isValid = true;

        if (this.state.fields.search.trim() === "") {
            errors.search = "Search value is required";
            isValid = false;
        } else {
            errors.search = "";
        }

        this.setState({ errors });
        return isValid;
    }

    onSubmit(e: any) {
        e.preventDefault();
        this.setState({ loading: true, errMsg: "" });

        if (this.ValidateProfile()) {
            let modal = this.state.modal;
            modal["modalSpinnerShow"] = true;
            this.setState({ modal });

            const searchValue =
                this.state.fields.search && this.state.fields.search !== ""
                    ? this.state.fields.search.replace("*", "%")
                    : "%";

            const data = {
                "p_FromDate": this.state.fields.fromDate,
                "p_ToDate": this.state.fields.toDate,
                "p_SearchValue": searchValue,
                "p_SearchField": this.state.fields.searchField
            };

            console.log(data,"dataCheck")

            let commonController = new CommonController();
            commonController
                .getUserActivity(data)
                .then((response: any) => {
                    let modalData = this.state.modal;
                    modalData["modalSpinnerShow"] = false;

                    if (
                        response &&
                        
                        response.data.length > 0
                    ) {
                        const jsonUsers: IUserActivityItem[] = [];

                        response.data.forEach((item: any) => {
                            jsonUsers.push({
                                User_ID: item.User_ID || item.user_id || "",
                                Name: item.user_name || item.user_name || "",
                                User_Type: item.user_type_id || item.user_type_id || "",
                                Logged_In:
                                    item.is_logged_in != null
                                        ? item.is_logged_in.toString()
                                        : item.is_logged_in != null
                                        ? item.is_logged_in.toString()
                                        : "",
                                Last_Logged_In: this.formatDisplayDate(
                                    item.logged_in_date || item.logged_in_date
                                ),
                                Last_Logged_Out: this.formatDisplayDate(
                                    item.logged_out_date || item.logged_out_date
                                ),
                                Last_Activity: this.formatDisplayDate(
                                    item.last_activity_date || item.last_activity_date
                                ),
                                Shadow: item.Shadow || "",
                                URL_Used: item.HTTP_REFERER || item.HTTP_REFERER || "",
                                Script:
                                    item.script_name ||
                                    item.script_name ||
                                    item.script_name ||
                                    "",
                                Agent: item.Agent || item.AGENT || "",
                                
                            });
                        });

                        this.setState({
                            users: jsonUsers,
                            loading: false,
                            errMsg: "",
                            modal: modalData
                        });
                    } else {
                        this.setState({
                            users: [],
                            loading: false,
                            errMsg: "No Records Found",
                            modal: modalData
                        });
                    }
                })
                .catch((error: any) => {
                    let modalData = this.state.modal;
                    modalData["modalSpinnerShow"] = false;

                    console.error("There was an error!", error);
                    this.setState({
                        loading: false,
                        errMsg: "Unable to fetch user activity details",
                        modal: modalData
                    });
                });
        } else {
            this.setState({ loading: false });
        }
    }

    cancelButton() {
        let fields = this.state.fields;
        fields["forValue"] = "Last 3 days";
        fields["fromDate"] = this.formatDateForInput(
            new Date(new Date().setDate(new Date().getDate() - 3))
        );
        fields["toDate"] = this.formatDateForInput(new Date());
        fields["search"] = "*";
        fields["searchField"] = "User ID";

        this.setState({
            fields,
            errMsg: "",
            users: []
        });
    }

     onShadow(userId: string){
           sessionStorage.setItem('shadow',sessionStorage.getItem('uid')!);
           let commonController = new CommonController();
           commonController.getUser(userId).then(response => {
               if(sessionStorage.getItem("user_type_id") === "R"){
                   this.props.history.push('/admin/trackinggrid');
               }
               else if(sessionStorage.getItem("user_type_id") === "A"){
                   this.props.history.push('/admin/approverinbox');  
               }
               else if(sessionStorage.getItem("user_type_id") === "W"){
                   sessionStorage.setItem('ShadowAdmin', '1' ) 
                   this.props.history.push('/admin/wtpincomingta');
               }
               else if(sessionStorage.getItem("user_type_id") === "CT"){
                   sessionStorage.setItem('ShadowAdmin', '1' ) 
                   this.props.history.push('/admin/wtpincomingta');
               }
               else{
                   this.props.history.push('/admin/home');
               }
               this.setState({ loading: false });
           }).catch(error => {
               console.error("There was an error!", error);
           })
       }

    render() {
        const { loading } = this.state;

        return (
            <div className="content">
                <FormModalSpinner show={this.state.modal.modalSpinnerShow} />

                <Container fluid>
                    <Row>
                        <Col sm={12}>
                            <Card border="light" style={{ width: "100%" }}>
                                <div className="header">
                                    <h4 className="title">eTA - User Activity</h4>
                                    <p className="category"></p>
                                </div>

                                <Card.Body>
                                    <Alert
                                        variant="danger"
                                        style={{
                                            display: this.state.errMsg ? "inherit" : "none"
                                        }}
                                    >
                                        {this.state.errMsg}
                                    </Alert>

                                    <Form onSubmit={this.onSubmit}>
                                        <Row>
                                            <Col sm={1}>
                                                <Form.Label style={{ fontWeight: "bold" }}>
                                                    For
                                                </Form.Label>
                                            </Col>
                                            <Col sm={2}>
                                                <Form.Control
                                                    as="select"
                                                    name="forValue"
                                                    value={this.state.fields.forValue}
                                                    onChange={this.handleForValueChange}
                                                >   <option>All</option>
                                                    <option>Last 3 days</option>
                                                    <option>Last 7 days</option>
                                                    <option>Last 30 days</option>
                                                    <option>Last 45 days</option>
                                                    <option>Last 60 days</option>
                                                    <option>Last 90 days</option>
                                                    <option>Custom</option>
                                                </Form.Control>
                                            </Col>

                                            <Col sm={2}>
                                                <Form.Control
                                                    type="date"
                                                    name="fromDate"
                                                    value={this.state.fields.fromDate}
                                                    onChange={this.handleChange}
                                                />
                                            </Col>

                                            <Col sm={1} style={{ textAlign: "center", paddingTop: "8px" }}>
                                                 <Form.Label style={{ fontWeight: "bold" }}>
                                                    and
                                                </Form.Label>
                                            </Col>

                                            <Col sm={2}>
                                                <Form.Control
                                                    type="date"
                                                    name="toDate"
                                                    value={this.state.fields.toDate}
                                                    onChange={this.handleChange}
                                                />
                                            </Col>
                                        </Row>

                                        <br />

                                        <Row>
                                            <Col sm={1}>
                                                <Form.Label style={{ fontWeight: "bold" }}>
                                                    Find
                                                </Form.Label>
                                            </Col>

                                            <Col sm={4}>
                                                <Form.Control
                                                    type="text"
                                                    name="search"
                                                    value={this.state.fields.search}
                                                    maxLength={100}
                                                    onChange={this.handleChange}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {this.state.errors.search}
                                                </div>
                                            </Col>

                                            <Col sm={1} style={{ textAlign: "center", paddingTop: "8px" }}>
                                                  <Form.Label style={{ fontWeight: "bold" }}>
                                                    in
                                                </Form.Label>
                                            </Col>

                                            <Col sm={2}>
                                                <Form.Control
                                                    as="select"
                                                    name="searchField"
                                                    value={this.state.fields.searchField}
                                                    onChange={this.handleChange}
                                                >
                                                    <option>Name</option>
                                                    <option>User ID</option>
                                                    <option>Global Id</option>
                                                </Form.Control>
                                            </Col>

                                            <Col sm={1} style={{ paddingTop: "8px" }}>
                                              <Form.Label style={{ fontWeight: "bold" }}>
                                                    field
                                                </Form.Label>
                                            </Col>

                                            <Col sm={3} style={{ textAlign: "right" }}>
                                                <Button
                                                    type="submit"
                                                    size="sm"
                                                    disabled={loading}
                                                    style={{ marginRight: "5px" }}
                                                >
                                                    {loading && (
                                                        <i
                                                            className="fa fa-refresh fa-spin"
                                                            style={{
                                                                marginRight: "5px",
                                                                color: "#487afa"
                                                            }}
                                                        />
                                                    )}
                                                    {loading && (
                                                        <span style={{ color: "#487afa" }}>
                                                            wait...
                                                        </span>
                                                    )}
                                                    {!loading && <span>Search</span>}
                                                </Button>

                                                <Button
                                                    type="button"
                                                    size="sm"
                                                    onClick={this.cancelButton}
                                                >
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <br />

                  <Row>
    <Col sm={12}>
        <Card border="light" style={{ width: "100%" }}>
            <div className="header">
                <h4 className="title">User Activity Details</h4>
                <p className="category"></p>
            </div>

            <Card.Body>
                <div
                    className="scroll"
                    style={{ width: "100%", maxHeight: "400px", overflowY: "auto" }}
                >
                    <Table bordered hover responsive>
                        <thead
                            style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                backgroundColor: "#ffffff"
                            }}
                        >
                            <tr>
                                <th>User ID</th>
                                <th>Name</th>
                                <th>User Type</th>
                                <th>Logged In</th>
                                <th>Last Logged In</th>
                                <th>Last Logged Out</th>
                                <th>Last Activity</th>
                                <th>Last Page Visited</th>
                                <th>URL_Used</th>
                                <th>Shadow</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.users.length === 0 ? (
                                <tr>
                                    <td colSpan={10} style={{ textAlign: "center" }}>
                                        No records available
                                    </td>
                                </tr>
                            ) : (
                                this.state.users.map((prop, key) => {
                                    return (
                                        <React.Fragment key={key}>
                                            <tr>
                                                <td>{prop.User_ID}</td>
                                                <td>{prop.Name}</td>
                                                <td>{prop.User_Type}</td>
                                                <td>{prop.Logged_In}</td>
                                                <td>{prop.Last_Logged_In}</td>
                                                <td>{prop.Last_Logged_Out}</td>
                                                <td>{prop.Last_Activity}</td>
                                                <td>{prop.Script}</td>
                                                <td>{prop.URL_Used}</td>
                                                <td>
                                                    {prop.User_Type !== "S" && prop.User_Type !== "DEL" ? (
                                                        <Button
                                                            type="button"
                                                            size="sm"
                                                            onClick={() => { this.onShadow(prop.User_ID) }}
                                                        >
                                                            Shadow
                                                        </Button>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    </Col>
</Row>




                </Container>
            </div>
        );
    }
}